import React, { useState } from "react";
import "./whyChooseDms.css";

import {
  FiMapPin,
  FiMessageCircle,
  FiLayers,
  FiShield,
  FiDatabase,
  FiSmartphone,
  FiBarChart2,
  FiCloud,
  FiArrowRight,
} from "react-icons/fi";
import DmsBookingModal from "./dmsBookingModal";

const features = [
  {
    icon: FiMapPin,
    title: "Real-Time GPS Tracking",
    text: "Track your sales team live on Google Maps, monitor field movement and get better visibility into retailer visits and territory activity.",
  },
  {
    icon: FiMessageCircle,
    title: "WhatsApp Integration",
    text: "Keep retailers informed through WhatsApp with order confirmations, invoice sharing and timely communication throughout the sales process.",
  },
  {
    icon: FiLayers,
    title: "Multi-Tenant Architecture",
    text: "Support multiple businesses or tenants on a scalable architecture with separated data environments and controlled access.",
  },
  {
    icon: FiShield,
    title: "Secure & Controlled",
    text: "Protect business and distribution data with secure access, role-based controls and a platform designed for enterprise operations.",
  },
  {
    icon: FiDatabase,
    title: "ERP & Business Integration",
    text: "Connect DMS with ERP, CRM, accounting, inventory, warehouse and other business applications through integration workflows and APIs.",
  },
  {
    icon: FiSmartphone,
    title: "Mobile-Ready Field Operations",
    text: "Give sales teams mobile access to orders, retailer visits, attendance, collections, beat planning and GPS-enabled field activity.",
  },
  {
    icon: FiBarChart2,
    title: "Real-Time Business Visibility",
    text: "Monitor sales, inventory, distributor performance, retail coverage, collections and territory activity through connected dashboards.",
  },
  {
    icon: FiCloud,
    title: "Scalable Cloud Platform",
    text: "Deploy a cloud-enabled distribution platform that can grow with your business, support multiple warehouses and adapt to changing requirements.",
  },
];

const WhyChooseDms = () => {
  const [showDmsModal, setShowDmsModal] = useState(false);
  const handleEnquiry = () => {
    const enquiryButton = document.querySelector("#enquiry-button");

    if (enquiryButton) {
      enquiryButton.click();
    }
  };

  return (
    <>
    <section className="why-choose-dms-section">
      <div className="why-choose-dms-glow why-choose-dms-glow-one"></div>
      <div className="why-choose-dms-glow why-choose-dms-glow-two"></div>

      <div className="container">
        <div
          className="why-choose-dms-heading"
          data-aos="fade-up"
          data-aos-duration="850"
        >
          <span className="why-choose-dms-label">
            WHY CHOOSE TECHCOGNICS DMS
          </span>

          <h2>
            Built for Smarter
            <br />
            <span>Distribution Operations</span>
          </h2>

          <p>
            Go beyond basic order management with connected field operations,
            channel visibility, secure architecture and intelligent distribution
            workflows.
          </p>
        </div>

        <div className="why-choose-dms-grid">
          {features.map((feature, index) => {
            const Icon = feature.icon;

            return (
              <div
                className="why-choose-dms-card"
                key={feature.title}
                data-aos="fade-up"
                data-aos-duration="700"
                data-aos-delay={index * 80}
              >
                <div className="why-choose-dms-card-top">
                  <div className="why-choose-dms-icon">
                    <Icon />
                  </div>

                  <span className="why-choose-dms-number">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                </div>

                <h3>{feature.title}</h3>

                <p>{feature.text}</p>

                <span className="why-choose-dms-line"></span>
              </div>
            );
          })}
        </div>

        <div
          className="why-choose-dms-cta"
          data-aos="fade-up"
          data-aos-duration="800"
          data-aos-delay="250"
        >
          <button
            type="button"
            className="why-choose-dms-cta-btn"
            onClick={() => setShowDmsModal(true)}
          >
            Talk to a DMS Expert
            <span>
              <FiArrowRight />
            </span>
          </button>
        </div>

        <div
          className="why-choose-dms-bottom"
          data-aos="fade-up"
          data-aos-duration="700"
          data-aos-delay="350"
        >
          <span className="why-choose-dms-bottom-line"></span>

          <p>
            Secure. Connected. Scalable. Built around your distribution network.
          </p>

          <span className="why-choose-dms-bottom-line"></span>
        </div>
      </div>
    </section>
    <DmsBookingModal
        show={showDmsModal}
        onClose={() => setShowDmsModal(false)}
      />
    </>
  );
};

export default WhyChooseDms;
